import { render, staticRenderFns } from "./emaillayout3.vue?vue&type=template&id=3213700a"
import script from "./emaillayout3.vue?vue&type=script&lang=js"
export * from "./emaillayout3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports